import { selectGroups } from '../../reducers/groupsReducer.js';
import { fetchGroups } from '../../fetch/documents.js';
import { selectLoadingRecentDocuments } from '../../reducers/groupsReducer.js';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLangObj } from '../../reducers/langReducer.js';
import SliderElement from '../slider/SliderElement.js';
import SliderItem from '../../models/SliderItem.js';
import DocumentSlider from '../slider/DocumentSlider.js';
import MoreInfo from './MoreInfo.js';
import GridType from '../../models/GridType.ts';


function Groups(props) {
  const groups = useSelector(selectGroups);
  const dispatch = useDispatch();
  const langObj = useSelector(selectLangObj);

  const appendItems = () => {
    dispatch(fetchGroups());
  }
  useEffect(() => {

    appendItems();
  }, []);

  function getItems(g){


    return g.map(e => { return new SliderItem(e.рбр,  e.наслов, e.линк,e.линк,e.датум, e.прикупио); }).map(e => {

      return (
        <SliderElement href={"/Members/"+e.id} link={true} auto={false} key={e.url} data={e}></SliderElement>
      )
    })
  }

  return (
    
    /* {
           "рбр": 24,
           "тип": "Фото",
           "име": "АЦ0001",
           "наслов": "фотографија",
           "датум": "2024-10-29",
           "прикупио": "С. Тришић",
           "период": 0,
           "линк": "https://i.ibb.co/sRBNGHV/img002.jpg",
           "линкП": "https://ibb.co/9gM1Ltr"

           {
                               items && items.map(e => {

                                   return (s
                                       <SliderElement data={e}></SliderElement>
                                   )
                               })
                           }
       }, */
    <DocumentSlider moreElement={<MoreInfo  moreLink={"/Grid/" + GridType.Groups}/>} title={langObj["Groups"]} appendItems={appendItems} getItems={()=>getItems(groups)}  ></DocumentSlider>
  );
}

export default Groups;
